//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash.debounce';
import Float from '@/js/float';

export default {
    name: 'combinedPayBankList',
    components: {

    },
    props: {
        actualAmount: [Number, String],
        bankList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        themeType: String,
        value: Boolean,
        isChooseGold: String,
        vipVo: {
            type: Object,
        },
    },
    data() {
        return {
            combinedBankList: JSON.parse(JSON.stringify(this.bankList)),
            isShow: false,
            currentInputBankIndex: 0,
            checkedBankList: [],
            keyboardDomHeight: 0,
            scrollHeight: 0,
            maxDistance: 30,
            showPop: this.value,
        }
    },
    computed: {
        currentInputBank() {
            return this.combinedBankList[this.currentInputBankIndex];
        },
        slideUpStyles() {
            if (this.scrollHeight > 0) {
                return {
                    marginBottom: this.scrollHeight + 'px'
                }
            }
            return {}
        },
        showVipAmount() {
            return this.isChooseGold === 'y' && this.vipVo;
        }
    },
    created() {
        this._debounce = debounce((val) => {
            const formatChecked = this.amountFormatCheck(val);
            if (formatChecked) {
                this.amountBizCheck(val);
            }
            if (this.currentInputBank.amount != this.actualAmount && this.currentInputBank.only === true) {
                this.setTargetStatus({ only: false }, this.currentInputBank);
            }
            this.combinedBankList.forEach(x => {
                if (x.cardNum != this.currentInputBank.cardNum) {
                    const _checkStatus = this.currentInputBank.valid === false || this.currentInputBank.only === true;
                    this.setTargetStatus({ checkStatus: _checkStatus ? 2 : 0 }, x);
                }
            })
        }, 200);
        this.sensorsRecord("h5_element_imp", {
            tgt_event_id: 'h5_paycash_combindedrepay_popup',
            tgt_name: 'h5-paycash-确认还款页-组合支付弹窗',
            url: location.href,
            page: '还款-确认还款页',
        });
    },
    watch: {
        'checkedBankList.length': {
            handler(val) {
                this.combinedBankList.forEach(x => {
                    if (x.checkStatus != 1) {
                        this.setTargetStatus({ checkStatus: val >= 2 ? 2 : 0 }, x);
                    }
                })
            },
        },
        value() {
            this.showPop = this.value
        },
        showPop() {
            this.$emit('input', this.showPop)
        }
    },
    methods: {
        deleteHandle() {
            const _amount = this.currentInputBank.amount;
            this.setTargetStatus({ amount: _amount.slice(0, _amount.length - 1) });

            if (this.checkedBankList.length >= 2) {
                this.checkedBankList.splice(1, 1);
            }
        },
        onInput(value) {
            const shadowInputValue = (this.currentInputBank.amount || '') + String(value);
            if (/^0(\d)$/.test(shadowInputValue)) return;

            const float_regex = /^(\d+)(\.\d{0,2})?$/;
            if (float_regex.test(shadowInputValue)) {
                this.setTargetStatus({ amount: shadowInputValue });
            }

            if (this.checkedBankList.length >= 2) {
                this.checkedBankList.splice(1, 1);
            }
        },
        onShow() {
            // if (!this.keyboardDomHeight) {
            //     // 动画效果
            //     const keyboardDom = document.querySelector("#number-keyboard");
            //     this.keyboardDomHeight = parseFloat(Number(keyboardDom.offsetHeight).toFixed(2));

            //     if (this.targetDom) this.scrollHandle();
            // }
        },
        focusHandle(index, event) {
            if (this.combinedBankList[index].canInput === false) return;

            this.setCurrentInputBankIndex(index);
            this.isShow = true;

            this.targetDom = event.target;
            if (this.targetDom) this.scrollHandle();

        },
        blurHandle() {
            this.isShow = false;
            this.scrollHeight = 0;

            this.$nextTick(() => {
                this._debounce(this.currentInputBank.amount);
            })
        },
        setCurrentInputBankIndex(index) {
            this.currentInputBankIndex = index;
        },
        checkBank(index) {
            // 勾选按钮状态有3种，0：unchecked，1：checked，2：disabled
            const _bank = this.combinedBankList[index];
            if (_bank.checkStatus === 2) return;

            // 勾选逻辑
            if (!_bank.checkStatus) {
                if (this.checkedBankList.length <= 0) {
                    this.setTargetStatus({ checkStatus: 1 }, _bank);
                    this.checkedBankList.push(_bank);
                } else {
                    // 勾选第二张
                    if (this.checkedBankList[0] && !(this.checkedBankList[0].amount > 0)) {
                        this.setTargetStatus({ valid: false, message: "请输入还款金额" }, this.checkedBankList[0]);
                    } else {
                        const _amount = parseFloat(Float.subtract(this.actualAmount, this.checkedBankList[0].amount, 2));
                        this.checkedBankList.push(_bank);
                        this.setTargetStatus({
                            canInput: false,
                            amount: _amount,
                            checkStatus: 1,
                            valid: this.amountBizCheck(_amount, _bank)
                        }, _bank);
                    }
                }
            } else {
                // 取消勾选逻辑
                // 取消勾选第一张卡，重置第二张卡的逻辑
                if (this.checkedBankList[1] && _bank.cardNum === this.checkedBankList[0].cardNum) {
                    this.setTargetStatus({
                        canInput: true,
                        amount: '',
                        valid: false,
                        message: ''
                    }, this.checkedBankList[1]);
                }

                this.setTargetStatus({
                    checkStatus: 0,
                    amount: '',
                    valid: false,
                    message: '',
                    canInput: true,
                    only: false
                }, _bank);

                this.checkedBankList.splice(this.checkedBankList.findIndex(x => x.cardNum === _bank.cardNum), 1);
            }
        },
        setTargetStatus(params, target) {
            const _target = target || this.currentInputBank;
            for (let _key in params) {
                this.$set(_target, _key, params[_key]);
            }
        },
        amountFormatCheck(val) {
            // 金额格式校验
            if (Number.isNaN(parseFloat(val))) {
                this.setTargetStatus({ valid: false, message: "请输入还款金额" });
            } else if (val <= 0) {
                this.setTargetStatus({ valid: false, message: '还款金额大于0' });
            } else if (/^\d+(\.\d+)?$/.test(val)) {
                if (!/^\d+(\.\d{1,2})?$/.test(val)) {
                    this.setTargetStatus({ valid: false, message: '还款金额仅支持两位小数' });
                } else {
                    return true;
                }
            } else {
                this.setTargetStatus({ valid: false, message: "格式有误，请正确输入金额" });
            }
            return false;
        },
        amountBizCheck(val, target) {
            const _target = target || this.currentInputBank;
            // 金额业务逻辑校验
            const _amount = parseFloat(val);
            const singleLimit = _target.singleLimit;

            if (_amount > parseFloat(this.actualAmount)) {
                this.setTargetStatus({ valid: false, message: '输入金额大于所需还款金额' }, target);
            } else if (singleLimit && _amount > singleLimit) {
                this.setTargetStatus({ valid: false, message: `单笔还款金额上限${singleLimit}元${this.checkedBankList.length > 1 ? '，请修改首张银行卡还款金额' : ''}` }, target);
            } else if (_amount === parseFloat(this.actualAmount)) {
                this.setTargetStatus({ valid: true, message: "所选银行已达还款金额，可直接还款", only: true }, target);
                return true;
            } else {
                // 校验通过默认不展示文案
                this.setTargetStatus({ valid: true, message: "" }, target);
                return true;
            }
            return false;
        },
        repayApply() {
            // 金额校验
            if (this.checkedBankList.length > 2) {
                return this.showMsg("最多可选择两张卡进行组合还款");
            }

            if (this.checkedBankList.length <= 0) {
                return this.showMsg("请选择两张银行卡进行组合还款");
            }

            if (this.checkedBankList.length === 1) {
                if (!this.checkedBankList[0].valid) return;
                if (!this.amountBizCheck(this.checkedBankList[0].amount)) {
                    return;
                }
                if (this.checkedBankList[0].amount < this.actualAmount) {
                    return this.showMsg("输入金额小于所需还款金额");
                }
            }

            if (this.checkedBankList.length > 1 && this.checkedBankList.find(x => !x.valid)) {
                return;
            }

            const combinedRepayParams = {
                bankAccountPayInfo: this.checkedBankList.map(x => {
                    const { amount, singleLimit, userBankAccountId, bankID, bankName, cardNum } = x;

                    return {
                        detailAmount: parseFloat(amount),
                        limitAmount: singleLimit,
                        userBankAccountId,
                        bankId: bankID,
                        bankName,
                        cardNum
                    }
                }),
                repayApplyType: 2
            }

            this.$emit("repay-apply", combinedRepayParams);
        },
        scrollHandle() {
            if (this.keyboardDomHeight > 0) {
                const rect = this.targetDom.getBoundingClientRect();
                const bottomDistance = window.innerHeight - (rect.y || rect.top) - rect.height;

                if (bottomDistance <= this.keyboardDomHeight) {
                    this.scrollHeight = parseFloat((this.keyboardDomHeight - bottomDistance + this.maxDistance).toFixed(2));
                } else if ((bottomDistance - this.keyboardDomHeight) < this.maxDistance) {
                    this.scrollHeight = parseFloat((this.maxDistance - this.keyboardDomHeight + bottomDistance).toFixed(2));
                }
            } else {
                const _timer = setTimeout(() => {
                    const keyboardDom = document.querySelector(".combined-pay-number-keyboard");
                    this.keyboardDomHeight = parseFloat(Number(keyboardDom.offsetHeight).toFixed(2));
                    this.scrollHandle();

                    clearTimeout(_timer);
                }, 350)
            }
        },
        reset() {
            // 重置组件数据
            Object.assign(this, {
                combinedBankList: JSON.parse(JSON.stringify(this.bankList)),
                currentInputBankIndex: 0,
                checkedBankList: []
            })
        },
        showMsg(message) {
            this.$vux.toast.show({
                type: "text",
                text: message,
                width: "50%",
            });
        }
    }
}
